import { COPY_CUT_FILE_DATA } from '../../constants/copyFile';

const initialState = {
	copyFileData: {
		name: '',
		directory: '',
		isFoldes: false,
		action: '',
		siteName: ''
	}
};

const copyCutReducer = (state = initialState, action) => {
	switch (action.type) {
		case COPY_CUT_FILE_DATA:
			return {
				copyFileData: action.payload
			};
		default:
			return state;
	}
};

export default copyCutReducer;
